import { useState } from "react";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

const FAQS = [
  ["What is ShipAny?", "ShipAny is India's smart multi-courier shipping platform. It connects your business to multiple courier partners through one dashboard for rates, booking, labels, tracking, COD and NDR management."],
  ["How does courier comparison work?", "Enter pickup pincode, delivery pincode and weight. ShipAny checks every enabled courier partner on that lane and shows price, estimated delivery, rating and COD availability — you pick the best option."],
  ["Can I use multiple courier partners?", "Yes. That's the core of ShipAny — one account gives you access to every integrated courier partner without separate contracts or dashboards."],
  ["Does ShipAny support COD?", "Yes. COD orders, remittance tracking and settlement visibility are built into the dashboard."],
  ["Can I ship internationally?", "Yes. ShipAny supports international lanes from India to the USA, UK, UAE, Canada, Australia, Singapore, Europe and the Middle East with documentation and customs workflow support."],
  ["Can I integrate Shopify?", "Yes. Shopify orders can sync into ShipAny for automated courier selection, booking and tracking writeback."],
  ["Can I integrate WooCommerce?", "Yes. WooCommerce is supported alongside Shopify, Amazon, Flipkart, Meesho and your own website via API."],
  ["Can I ship Amazon/Flipkart/Meesho orders?", "Yes. Marketplace orders can be processed through ShipAny with the same rate comparison and tracking pipeline."],
  ["How does tracking work?", "Every partner's scans are normalized into one unified ShipAny timeline — from pickup to proof of delivery — with a branded public tracking page for your customers."],
  ["How does NDR management work?", "Failed deliveries appear in the NDR panel. ShipAny notifies the customer, collects the action (reattempt / address update), and schedules reattempts — reducing RTO."],
  ["How does courier pricing work?", "You pay per shipment from your prepaid wallet. Rates shown include the courier's charges plus a transparent platform margin — no subscriptions."],
  ["Can I process bulk shipments?", "Yes. Upload hundreds or thousands of orders via bulk upload and process them efficiently with the same comparison and booking engine."],
];

export default function FaqSection() {
  const [open, setOpen] = useState(0);
  return (
    <section className="bg-white py-20 text-shipany-navy sm:py-24" data-testid="faq-section">
      <div className="mx-auto max-w-3xl px-5">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6 }} className="text-center">
          <span className="text-xs font-bold uppercase tracking-[0.22em] text-[#FF9933]">FAQ</span>
          <h2 className="font-display mt-3 text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">Questions, Answered</h2>
        </motion.div>
        <div className="mt-10 space-y-3">
          {FAQS.map(([q, a], i) => {
            const isOpen = open === i;
            return (
              <div key={q} className={`overflow-hidden rounded-2xl border transition-colors ${isOpen ? "border-[#0757D9]/40 bg-[#F7FAFC]" : "border-slate-200 bg-white"}`}
                data-testid={`faq-accordion-item-${i + 1}`}>
                <button onClick={() => setOpen(isOpen ? -1 : i)} data-testid={`faq-question-${i + 1}`}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left">
                  <span className="text-sm font-bold">{q}</span>
                  <ChevronDown className={`h-4 w-4 shrink-0 text-[#0757D9] transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} />
                </button>
                <div className={`grid transition-all duration-300 ease-out ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                  <div className="overflow-hidden">
                    <p className="px-5 pb-4 text-sm leading-relaxed text-slate-500">{a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
